(function(args) { 

	let terms = [];

	if (args.terms) {
		terms = Object.entries(args.terms).map(([id, value]) => {					                		

			var country_current = jQuery('#form_projects_field_country').val(); 
			return `<option value="${id}" ${id == country_current ? 'selected="selected"' : ''}>${value}</option>`;
		});
	}

	document.getElementById(args.id).innerHTML = `
		<div class="form-field search-filter project-search-filter project-search-filter-country">
	        <select>
	        	<option value="" selected disabled hidden>Country</option>
	            <option value="0">All</option>
	            ${terms}
	        </select>
	        <span class="input-span">
	        	<span class="icons-svg icons-svg-caret-bottom"></span>
	        </span>		        
		</div>
	`;

	document.addEventListener('DOMContentLoaded', function() {
		document.addEventListener('change', function(e) {
			if (e.target.matches('.project-search-filter.project-search-filter-country select')) {
				document.getElementById('form_projects_field_country').value = e.target.value;
			} 
		});
	});

})(args);